import { IContentCard } from "data/contentData/interfaces/mongodb/IContentCard"

import PortableText from "Components/PortableText/PortableText"

export default function TopicContentCard({ card }: { card: IContentCard }) {
    return <PortableText value={card.blockContent} />
}
